<template>
    <div>
        <div class="row">
            <ul class="col-12 p-0 input-table no-borders ml-3">
                <li
                    class="d-flex justify-content-start"
                    v-for="(item, index) in items"
                    :key="index"
                >
                    <div class="input-table-shadow">
                        <div class="d-flex row align-items-center">
                            <div class="col-2 ml-3 border-right">
                                <core-money-input
                                    class="text-center"
                                    :placeholder="$t('travels.navigation.design.package-price-price')"
                                    :amount.sync="item.purchasePrice"
                                ></core-money-input>
                            </div>
                            <div class="col-3 border-right">
                                <core-date-range-calendar
                                    class="px-0 currency input-group d-flex justify-content-between align-items-center"
                                    :start.sync="item.dateFrom"
                                    :end.sync="item.dateUntil"
                                ></core-date-range-calendar>
                            </div>
                            <div class="col-2 border-right">
                                <price-element-min-adults
                                    :amount.sync="item.min"
                                ></price-element-min-adults>
                            </div>
                            <div class="col-2 border-right">
                                <select required="" class="right-chevron">
                                    <option value="">{{ $t('travels.navigation.design.package-price-class') }}</option>
                                    <option selected="" value="0">2nd class</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="pl-2 d-flex align-items-center">
                        <core-icon
                            @click.native="remove(index)"
                            class="pointer"
                            :iconName="$t('general.delete')"
                            iconColor="#bdbdbd"
                        >
                            <icons-close></icons-close>
                        </core-icon>
                    </div>
                </li>
            </ul>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <img
                    class="pl-3 mt-2 mb-5 add-row"
                    src="@/assets/svg/plus008CDD.svg"
                    @click="add({'arrivalDays': '1111111', 'dateFrom': $moment().format('YYYY-MM-DD'), 'dateUntil': '2099-01-01', 'min': null, 'max': null})"
                    :title="$t('general.add')"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { addItem } from '@/mixins/addItem'
import { cloneItem } from '@/mixins/cloneItem'
import { removeItem } from '@/mixins/removeItem'

export default {
  props: {
    prices: {
      default: () => ([]),
      type: Array,
      required: true
    }
  },
  mixins: [addItem, cloneItem, removeItem],
  data () {
    return {
      items: this.prices
    }
  },
  methods: {
    deleteItem () {
      this.$emit('delete')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/travel/PackagePrice.vue